import { Serializable } from '@admin/core/models/serializable';

export class StaticContentRawModel
  implements Serializable<StaticContentRawModel>
{
  fromObject(obj: any): StaticContentRawModel {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    let result = {
      StaticContentId: this.staticContentId,
      TitleResource: this.titleResource,
      ContentResource: this.contentResource,
      LanguageCode: this.languageCode,
    };
    return result;
  }

  public staticContentId: number;
  public titleResource: string;
  public contentResource: string;
  public languageCode: string;
}
